import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  Response,
  TQueryParams,
  formatQueryParams,
  parseJsonApiResponse,
  prepareHeaders,
} from 'evolve-ui';

export type TMunicipality = {
  id: string;
  name: string;
};

export const municipalitiesApi = createApi({
  reducerPath: 'municipalities',
  baseQuery: fetchBaseQuery({
    // TODO: change to countries api url
    baseUrl: `${process.env.GATSBY_OFFERS_API_URL}/municipalities`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Municipality'],
  endpoints: (builder) => ({
    getMunicipalities: builder.query<Response<TMunicipality>, TQueryParams>({
      providesTags: ['Municipality'],
      query: formatQueryParams,
      transformResponse: parseJsonApiResponse<TMunicipality>,
    }),
  }),
});

export const { useGetMunicipalitiesQuery } = municipalitiesApi;
